import React, { Component } from 'react'
import styles from "./LogInBtnStyle.module.css"

import SettingBar from "./SettingBar"
import firebaseFunc from "../FirebaseService/FirebaseFunc";

import REQUEST_LOGING_SRC from "../../static/icons8-login-32.png"
export default class LogInBtn extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: null,
            listBarFlag: false
        }
    }
    // handler
    logInHandler = (e) => {
        this.setState(state => { return { listBarFlag: !state.listBarFlag } })
    }

    updateSignStyle = () => {
        var userStyle = { img: REQUEST_LOGING_SRC }
        if (this.state.user)
            userStyle.img = this.state.user.photoURL

        return userStyle
    }

    componentDidMount() {
        firebaseFunc.getStateChange((user) => {
            console.log(user)
            this.setState(state => { return { user: user } })
        })
    }

    render() {

        const userStyle = this.updateSignStyle()
        const listBar = (this.state.listBarFlag) ? <SettingBar logInPath={this.props.logInPath} /> : ""

        return (
            <div className={styles.container}>
                <img className={styles.imgStyle} onClick={this.logInHandler} src={userStyle.img} alt="" />
                {listBar}
            </div>
        )
    }
}
